import React, { useMemo } from 'react';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import Avatar from '@mui/material/Avatar';
import TelegramIcon from '@mui/icons-material/Telegram';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { SvgIconProps } from '@mui/material/SvgIcon';
import { useLawyerContext } from '../../context/lawyer-info-context';

type Socials = {
  ariaLabel: string;
  link: string | undefined;
  icon: (props: SvgIconProps) => JSX.Element;
  sx: object;
}[];

export default function Socials(): JSX.Element {
  const lawyerInfo = useLawyerContext();

  const socialIcons = useMemo(
    (): Socials => [
      {
        ariaLabel: 'Telegram',
        link: lawyerInfo.telegramLink,
        icon: TelegramIcon,
        sx: {
          backgroundColor: 'telegram.main',
        },
      },
      {
        ariaLabel: 'WhatsApp',
        link: lawyerInfo.whatsAppLink,
        icon: WhatsAppIcon,
        sx: {
          backgroundColor: 'whatsapp.main',
        },
      },
      {
        ariaLabel: 'Viber',
        link: lawyerInfo.viberLink,
        icon: WhatsAppIcon,
        sx: {
          backgroundColor: 'viber.main',
        },
      },
    ],
    [lawyerInfo]
  );

  return (
    <>
      {socialIcons.map(({ ariaLabel, link, icon: Icon, sx }) => (
        <IconButton key={ariaLabel} aria-label={ariaLabel} color="inherit">
          <Tooltip title={<Typography>{ariaLabel}</Typography>} arrow>
            <Link href={link} target="_blank" rel="noopener" underline="none">
              <Avatar sx={sx}>
                <Icon />
              </Avatar>
            </Link>
          </Tooltip>
        </IconButton>
      ))}
    </>
  );
}
